import { render, staticRenderFns } from "./approval-read-record.vue?vue&type=template&id=50e151a6&scoped=true&"
import script from "./approval-read-record.vue?vue&type=script&lang=js&"
export * from "./approval-read-record.vue?vue&type=script&lang=js&"
import style0 from "./approval-read-record.vue?vue&type=style&index=0&id=50e151a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e151a6",
  null
  
)

export default component.exports